import React, { Fragment } from "react";
import { Formik } from "formik";
import Select from "react-select";
import PageTitle from "../../../layouts/PageTitle";
import { create, updateAction } from "../../../../store/actions/CommonActions";
import CustomTextarea from "../../../components/Forms/CustomInputs/CustomTextarea";
import { initiativeValidationSchema } from "../../../../utils/validationSchemas/MasterDataSchema";
import CustomDropdown from "../../../components/Forms/CustomInputs/CustomDropdown";
import { useSelector } from "react-redux";
import CustomImageUpload from "../../../components/Forms/CustomInputs/CustomImageUpload";
import CustomTextbox from "../../../components/Forms/CustomInputs/CustomTextbox";
import QrPass from "../../../components/QRPass/QrPass";
import DirectImageUpload from "../../Projects/forms/DirectImageUpload";

const ConfigQrPassUi = ({
  callback,
}) => {
  const data = useSelector((state) => state.systemconfig);
  let initialValues = {
    _id: data?._id || "",
    qr_pass_brand_image: data?.qr_pass_brand_image || ""
  };
  if (data) {
    initialValues = {
      _id: data._id || "",
      qr_pass_brand_image: data?.qr_pass_brand_image || ""
    };
  }
  return (
    <Fragment>

      <div className="row container-mxw">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">
                QR Pass Image
              </h4>
              <p>Upload and manage the promotional image displayed on QR passes.</p>
            </div>
            <div className="card-body">
              <div className="basic-form">
                {data ? (
                  <DirectImageUpload
                    fieldName="qr_pass_brand_image"
                    label="Upload image (1080px X 1929px)"
                    projectDetails={data}
                    imageRatio="16_9"
                    endPoint={"configs"}
                    callBack={callback}
                    allowSvg={true}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">
                QR Pass Preview
              </h4>
              <p>Preview of the QR pass with the current configuration.</p>
            </div>
            <div className="card-body d-flex justify-content-center">
              <div>
                <QrPass
                  memberCount={4}
                  name={'Abhivyakti'}
                  fullName={'Abhivyakti Pass'}
                  ticketId={"C1234"}
                  allowBtns={false}
                  // btnTxt={"Send QR to Whatsapp"}
                  btnTxt={"Download QR Pass"}
                  audienceData={{}}
                  qr={'test'}
                  customImage={true}
                  previewImageUrl={data?.qr_pass_brand_image}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ConfigQrPassUi;
